import { Settings } from '@mui/icons-material'
import { observer } from 'mobx-react-lite'
import { ReactElement } from 'react'
import { useUiStateStore } from '../../../store/uiState/UiStateStore'
import styled from 'styled-components'
import { Translate } from 'common'

export const CustomizeSearchButton = observer((): ReactElement => {
  const { setShowCustomizeSearchModal } = useUiStateStore()

  return (
    <Wrapper onClick={() => setShowCustomizeSearchModal(true)}>
      <SettingsIcon />
      {Translate('customizeSearch')}
    </Wrapper>
  )
})

const SettingsIcon = styled(Settings)`
  font-size: 18px;
  margin: auto 0px;
`

const Wrapper = styled.div`
  display: flex;
  gap: 4px;
  margin: auto;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 23px;
  color: ${(p) => p.theme.colors.link};
  cursor: pointer;
  text-wrap: nowrap;
`
